import React from "react";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { coerceDateValue } from "../../../utils/helper";
import "./DatePicker.scss";

export default function DatePickers({
  name,
  onChangeHandler,
  value,
  id,
  disabled = false,
  isError = false,
  errorMsg = "",
  maxDateEnable = false,
  minDate,
  views,
  inputFormat = "MM/dd/yyyy",
  maxDate= new Date(),
  testId,
  forceDesktop = false,
  clampToMaxDate = true,
}) {
  const resolvedTestId = testId || name || id || undefined;
  // On touch devices the responsive DatePicker renders the Mobile variant: a
  // transactional OK/Cancel dialog whose draft state does not commit correctly
  // with our string value, so selection is lost. forceDesktop pins the desktop
  // popper (immediate commit) so touch behaves like desktop.
  const PickerComponent = forceDesktop ? DesktopDatePicker : DatePicker;
  const boundedMaxDate =
    maxDate instanceof Date && !isNaN(maxDate.getTime()) ? maxDate : undefined;
  return (
    <div className="overideDatePicker" data-testid={resolvedTestId ? `${resolvedTestId}-wrapper` : undefined}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <PickerComponent
          views={views}
          autoFocus
          inputFormat={inputFormat}
          selected={new Date()}
          // onChange={(e) => onChangeHandler(e)}
          onChange={(e) => {
            let selectedDate = e ?? new Date();
            if (
              clampToMaxDate &&
              !maxDateEnable &&
              boundedMaxDate &&
              selectedDate > boundedMaxDate
            ) {
              selectedDate = boundedMaxDate;
            }
            onChangeHandler(selectedDate);
          }}
          maxDate={maxDateEnable ? undefined : boundedMaxDate}
          minDate={minDate ? minDate : "01/01/1970"}
          disabled={disabled}
          value={coerceDateValue(value)}
          id={id}
          name={name}
          className="formControlRoot"
          renderInput={(params) => (
            <TextField
              size="small"
              className="formControlRoot"
              InputProps={{
                className: "inputRoot",
              }}
              {...params}
              fullWidth
              name={name}
              inputProps={{
                ...params.inputProps,
                'data-testid': resolvedTestId ? `${resolvedTestId}-input` : undefined,
              }}
            />
          )}
          error={isError}
          helperText={errorMsg}
        />
      </LocalizationProvider>
      {isError &&
        // !value &&
         <p className="errorText">{errorMsg}</p>
         }
    </div>
  );
}
